module.exports = __webpack_public_path__ + "img/1.0bfa8872.jpg";